export interface GenerateForms151DraftPdfPayload {
  mod?: string;
  ejf?: string;
  fic?: string;
  idi?: string;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : undefined;
}

export function buildGenerateForms151DraftPdfPayload(input: any): GenerateForms151DraftPdfPayload {
  const payload: GenerateForms151DraftPdfPayload = {}

  const mod = toStringValue(input?.mod)
  if (mod !== undefined) payload.mod = mod

  const ejf = toStringValue(input?.ejf)
  if (ejf !== undefined) payload.ejf = ejf

  const fic = toStringValue(input?.fic)
  if (fic !== undefined) payload.fic = fic

  const idi = toStringValue(input?.idi)
  if (idi !== undefined) payload.idi = idi

  return payload
}
